import { render, staticRenderFns } from "./ProfileView.vue?vue&type=template&id=e5045218&scoped=true&"
import script from "./ProfileView.vue?vue&type=script&lang=js&"
export * from "./ProfileView.vue?vue&type=script&lang=js&"
import style0 from "./ProfileView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProfileView.vue?vue&type=style&index=1&id=e5045218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5045218",
  null
  
)

export default component.exports